<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px" color="white">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 200px">
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" sm="12" md="4" lg="4" v-for="evento in eventos" :key="evento.id">
                          <v-card outlined>
                            <v-alert v-if="evento.exibePorcentagem"
                              style="margin: 0px; text-align: center; border-radius: 0px" color="red" dark dense>
                              <b v-if="evento.exigePagamento">{{ (evento.quantidadeInscricoes * 100 /
                                evento.vagas).toFixed(0) }}% VENDIDOS</b>
                              <b v-else>{{ (evento.quantidadeInscricoes * 100 / evento.vagas).toFixed(0) }}%
                                VENDIDOS</b>
                            </v-alert>
                            <v-img class="mx-auto" height="auto" width="100%" :src="evento.urlCapa"></v-img>
                            <v-card-title class="mx-auto no-break">{{ evento.nome }}</v-card-title>
                            <v-card-text>
                              <div>
                                <v-icon>mdi-calendar</v-icon>
                                {{ formatDateHora(evento.inicio) }}
                              </div>
                              <div style="margin-top: 5px" v-if="evento.local">
                                <v-icon>mdi-map-marker</v-icon>
                                {{ evento.local }} <span v-if="evento.localizacao">(<a :href="evento.localizacao"
                                    target="_blank">Ver no mapa</a>)</span>
                              </div>
                              <div style="margin-top: 5px"
                                v-if="evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>
                                Setores disponíveis:
                                <ul style="margin: 0px; padding-left: 5px" v-for="valor in evento.setores"
                                  :key="valor.nome">
                                  <p :style="'margin: 0px; color: ' + valor.cor">
                                    <v-icon :color="valor.cor" size="12" style="padding-bottom: 2px">mdi-circle</v-icon>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </p>
                                </ul>
                              </div>
                              <div style="margin-top: 5px"
                                v-if="!evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>

                                <ul style="margin: 0px" v-for="valor in evento.setores" :key="valor.nome">
                                  <li>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </li>
                                </ul>
                              </div>
                              <div style="margin-top: 5px" v-if="evento.valorPix && evento.valorCartao">
                                <ul style="margin: 0px; padding-left: 5px">
                                  <p style="margin: 0px" v-if="evento.valorPix">
                                    <b>Pix:</b> {{ parseFloat(parseFloat(evento.valorPix.replace(',', '.')).toFixed(2) *
                                      evento.vendaMinima).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL"
                                      }) }}
                                  </p>
                                  <p style="margin: 0px" v-if="evento.valorCartao">
                                    <b>Cartão:</b> em até {{ evento.quantidadeParcelas }}x de {{ calculaParcelas(evento)
                                    }}
                                  </p>
                                </ul>
                              </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn dark depressed color="#0D47A1" @click="realizarInscricaoGrupo(evento)"
                                :disabled="evento.quantidadeInscricoes >= evento.vagas">Comprar
                                agora</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-flex xs12 sm12 lg12 style="text-align: center; padding: 0px 10px 0px 10px; margin-bottom: 17px">
                      <v-card flat>
                        <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="300px">
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="empresa.telefone" style="padding: 0px 10px 0px 10px">
                      <v-btn depressed block style="border-radius: 7px" large
                        :href="'https://wa.me/55' + empresa.telefone + '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' + empresa.nome + '?'"
                        target="_blank">
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center v-else-if="eventos.length == 0">
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados do cartão de crédito:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="pagamento.nomeTitular" label="NOME IMPRESSO NO CARTÃO" single-line
                        outlined color="#00695C" dense hide-details required v-validate="'required'"
                        :error-messages="errors.collect('nomeCartao')" data-vv-name="nomeCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light v-model="pagamento.cartaoNumero" v-mask="maskCartao" label="NÚMERO DO CARTÃO"
                        single-line outlined color="#00695C" dense hide-details required v-validate="'required'"
                        :error-messages="errors.collect('numCartao')" data-vv-name="numCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.cpfTitular" v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')"
                        data-vv-name="cpftitular" label="CPF DO TITULAR" single-line outlined color="#00695C" dense
                        hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-text-field light v-mask="'###'" v-model="pagamento.cvv" label="CVV" single-line outlined
                        color="#00695C" dense hide-details type="password" required v-validate="'required'"
                        :error-messages="errors.collect('codCartao')" data-vv-name="codCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.mesVencimento" :items="mesesVencimento" hide-details
                        item-text="titulo" item-value="id" color="#00695C" label="MÊS VENCIMENTO"
                        v-validate="'required'" :error-messages="errors.collect('expiraCartaoMes')"
                        data-vv-name="expiraCartaoMes"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.anoVencimento" :items="anosVencimento" hide-details
                        item-text="titulo" item-value="id" color="#00695C" label="ANO VENCIMENTO"
                        v-validate="'required'" :error-messages="errors.collect('expiraCartaoAno')"
                        data-vv-name="expiraCartaoAno"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="pagamento.bandeira" :items="bandeiras" hide-details
                        item-text="text" item-value="value" color="#00695C" label="BANDEIRA" v-validate="'required'"
                        :error-messages="errors.collect('bandeira')" data-vv-name="bandeira"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="pagamento.valorEscolhido" :items="parcelas" hide-details
                        color="#00695C" label="PARCELAS" v-validate="'required'"
                        :error-messages="errors.collect('parcelas')" data-vv-name="parcelas"
                        @input="carregaQtdParcelas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha as informações de endereço e e-mail</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-mask="'#####-###'" v-model="pagamento.cep" label="CEP" single-line outlined
                        type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.numero" label="NÚMERO DO ENDEREÇO" single-line outlined
                        type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="pagamento.email" label="E-MAIL" single-line outlined color="#00695C"
                        dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs10 sm10 lg12 style="margin-top: 20px">
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h4 style="color:#1E3A8A">{{ eventoSelecionado.nome }}</h4>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h2 style="color:#1E3A8A" v-if="!textoParcela">Total: {{ valorTotalCompra.toLocaleString("pt-BR",
                        { style: "currency", currency: "BRL" }) }}</h2>
                      <h2 style="color:#1E3A8A" v-else>{{ textoParcela }}</h2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large
                        @click="pagamentoCartao">Realizar Pagamento</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large
                        @click="cancelarPagamento">Cancelar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img src="../../assets/site-seguro-blindado.png" width="100%" style="max-width: 280px">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja consultar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id"
                        color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados abaixo para consultar a inscrição:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="'###.###.###-##'" dense
                        hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')"
                        data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large
                        @click="consultarInscricao(cpf)">Consultar Inscrição</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->

        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info" style="margin-top: 15px">
                        Você está usando o link do divulgador {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center" v-if="eventoSelecionado.urlMapa">
                      <h3 style="margin: 0px">Mapa do evento</h3>
                      <img :src="eventoSelecionado.urlMapa" alt="MapaEvento" width="100%"
                        style="max-width: 500px; margin-top: 10px">
                    </v-flex>
                  </v-layout>
                </v-container>
                  
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados da empresa:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="empresaCompra.cpfCnpj"
                        light
                        color="#00695C"
                        outlined
                        v-mask="mascaraDocumento"
                        dense
                        hide-details
                        required
                        type="tel"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field
                        label="NOME DA EMPRESA"
                        v-model="empresaCompra.nome"
                        light
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        label="WHATSAPP COM DDD"
                        v-model="empresaCompra.telefone"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        hide-details
                        v-mask="'(##) #####-####'"
                        dense
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        label="E-MAIL"
                        v-model="empresaCompra.email"
                        light
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha seu endereço:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        label="CEP"
                        v-model="empresaCompra.cep"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        hide-details
                        v-mask="'#####-###'"
                        dense
                        required
                        @blur="retornoCEP"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field
                        light
                        v-model="empresaCompra.logradouro"
                        label="RUA"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        :readonly="!cepNotCaptured"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="empresaCompra.estado"
                        label="ESTADO"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        :readonly="!cepNotCaptured"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="empresaCompra.cidade"
                        label="CIDADE"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        :readonly="!cepNotCaptured"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="empresaCompra.bairro"
                        label="BAIRRO"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        :readonly="!cepNotCaptured"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        light
                        v-model="empresaCompra.numero"
                        label="Nº"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 25px">
                      <v-card outlined class="pa-4">
                        <v-card-title class="px-0 pt-0">
                          <v-icon left color="#00695C">mdi-ticket-confirmation</v-icon>
                          Quantidade de Ingressos
                        </v-card-title>
                        
                        <v-card-text class="px-0 pb-0">
                          <v-select 
                            :disabled="eventoSelecionado.vendaMinima > 1" 
                            outlined 
                            dense 
                            hide-details
                            v-model="qtdCompra" 
                            :items="quantidade" 
                            @input="verificaCapacidade()"
                            placeholder="Selecione a quantidade"
                            color="#00695C"
                          ></v-select>

                          <v-slide-y-transition>
                            <v-alert
                              v-if="qtdCompra === 6"
                              type="success"
                              dense
                              text
                              color="#2E7D32"
                              class="mt-4 mb-0"
                              style="background: #E8F5E9; border: 1px dashed #2E7D32;"
                            >
                              <div class="d-flex align-center">
                                <v-icon left color="#2E7D32">mdi-gift</v-icon>
                                <div>
                                  <span class="font-weight-bold">Parabéns!</span>
                                  <br>
                                  <span>Você ganhou 1 ingresso grátis!</span>
                                </div>
                              </div>
                            </v-alert>
                          </v-slide-y-transition>

                          <v-slide-y-transition>
                            <v-alert
                              v-if="qtdCompra === 10"
                              type="success"
                              dense
                              text
                              color="#2E7D32"
                              class="mt-4 mb-0"
                              style="background: #E8F5E9; border: 1px dashed #2E7D32;"
                            >
                              <div class="d-flex align-center">
                                <v-icon left color="#2E7D32">mdi-gift</v-icon>
                                <div>
                                  <span class="font-weight-bold">Parabéns!</span>
                                  <br>
                                    <span>Você ganhou 2 ingressos grátis!</span>
                                </div>
                              </div>
                            </v-alert>
                          </v-slide-y-transition>
                        </v-card-text>

                        <v-card-actions class="px-0 pt-4">
                          <v-switch 
                            inset 
                            v-model="exibePreenchimento" 
                            label="Deseja informar os dados dos participantes agora?"
                            color="#00695C"
                          ></v-switch>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index" v-show="exibePreenchimento">
                  <v-layout row wrap justify-left style="margin-bottom: 20px">
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;" v-if="qtdCompra != 1">Dados do {{ index }}º participante:</p>
                      <p style="margin-bottom: 0px;" v-else>Dados do participante:</p>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                      <v-radio-group v-model="inscricao[index - 1].tipoDocumento" row>
                        <v-radio label="CPF" value="CPF"></v-radio>
                        <v-radio label="CNPJ" value="CNPJ"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                      <v-text-field label="CPF" v-model="inscricao[index - 1].cpf" light color="#00695C" outlined
                        v-mask="'###.###.###-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CPF')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4
                      v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                      <v-text-field label="CNPJ" v-model="inscricao[index - 1].cpf" light color="#00695C" outlined
                        v-mask="'##.###.###/####-##'" dense hide-details required type="tel"
                        @change="verificaDocumento(inscricao[index - 1].cpf, index - 1, 'CNPJ')"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg8
                      v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao[index - 1].tipoDocumento == 'CPF'">
                      <v-text-field label="NOME COMPLETO" v-model="inscricao[index - 1].nome" light single-line outlined
                        color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8
                      v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao[index - 1].tipoDocumento == 'CNPJ'">
                      <v-text-field label="RAZÃO SOCIAL" v-model="inscricao[index - 1].nome" light single-line outlined
                        color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="NOME PARA O CRACHÁ" v-model="inscricao[index - 1].nomeCracha" light
                        color="#00695C" outlined hide-details dense required maxlength="26"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="CARGO" v-model="inscricao[index - 1].cargo" light color="#00695C" outlined
                        hide-details dense required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select label="SEXO" v-model="inscricao[index - 1].sexo" outlined dense :items="sexo"
                        hide-details item-text="titulo2" item-value="id" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="WHATSAPP COM DDD" v-model="inscricao[index - 1].telefone" light
                        color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="E-MAIL" v-model="inscricao[index - 1].email" light outlined color="#00695C"
                        dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field label="DATA DE NASCIMENTO" v-model="inscricao[index - 1].dataNascimento" light
                        color="#00695C" type="text" outlined hide-details v-mask="'##/##/####'" dense
                        required></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-select label="SETOR" v-model="inscricao[index-1].setor" outlined dense :items="eventoSelecionado.setores" hide-details item-text="nome" item-value="nome" color="#00695C" @input="calculaValorTotal(inscricao[index-1].setor, index-1)"></v-select>
                    </v-flex> -->
                    <!-- <v-flex>
                      <v-btn v-if="index - 1 != 0" block depressed dark color="#00695C"
                        @click="preencherInformacoes(index - 1)">Preencher
                        informações</v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-divider v-if="index != qtdCompra" style="margin-top: 40px"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 10px">
                      <template v-slot:label>
                        <div>
                          Concordo com as <a target="_blank"
                            href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf"
                            @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: #1E3A8A">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <h3 style="color:#1E3A8A"
                      v-if="indicacao && divulgador.aplicaDesconto && eventoSelecionado.usaLinkDesconto">
                      <p style="margin: 0px">{{ valorTotalCompra.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      }) }} <span style="color: green"> - {{ divulgador.valorDesconto }}% de desconto do
                          indicador</span></p>
                      <p>Total: {{ parseFloat(valorTotalCompra - (valorTotalCompra * divulgador.valorDesconto /
                        100)).toLocaleString("pt-BR",
                          { style: "currency", currency: "BRL" }) }}</p>
                    </h3>
                    <h3 style="color:#1E3A8A" v-else>
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large
                        @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px">
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large
                        @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px">
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
             <img src="../../assets/logoAICheckinIntelite.png" width="250px" />
          </a>
        </div>

        <v-dialog v-model="dialogoIngressoIndividual" persistent max-width="380px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingresso Digital</span>
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #FFFFFF;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ inscricaoLocalizada.nome }}</h3>
              </div>
              
              <div v-if="!inscricaoLocalizada.autopreenchimento" style="display: flex; justify-content: center; margin: 20px 0;">
                <div style="border: 1px solid #E0E7FF; padding: 12px; background-color: #FFFFFF; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <enhanced-qr-code 
                      :value="inscricaoLocalizada.cod_incricao" 
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p style="margin: 8px 0 0 0; font-size: 13px; font-weight: 500; color: #4B5563; text-align: center;">{{ inscricaoLocalizada.cod_incricao }}</p>
                  </div>
                </div>
              </div>
              
              <div v-if="inscricaoLocalizada.autopreenchimento" style="display: flex; justify-content: center; margin: 20px 0;">
                <router-link :to="'/editinsc?cod=' + inscricaoLocalizada.cod_incricao" style="text-decoration: none; width: 200px;">
                  <div style="border: 1px solid #FED7AA; padding: 12px; background-color: #FFF7ED; border-radius: 12px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.05); text-align: center; width: 100%; cursor: pointer; transition: all 0.2s ease; position: relative; overflow: hidden;" class="qrcode-area-clicavel">
                    <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(245, 158, 11, 0.1); opacity: 0; transition: opacity 0.3s ease;" class="hover-overlay"></div>
                    <v-icon style="color: #F59E0B; font-size: 64px; margin-bottom: 8px;">mdi-qrcode-scan</v-icon>
                    <p style="margin: 0; font-size: 15px; font-weight: 500; color: #92400E; text-align: center;">QR Code indisponível</p>
                    <p style="margin: 8px 0 0 0; font-size: 13px; color: #92400E; text-align: center;">Clique aqui e complete seu cadastro para gerar o QR Code</p>
                    <v-btn style="margin-top: 12px; border-radius: 8px; text-transform: none; height: 36px; font-weight: 500; letter-spacing: 0.3px;" x-small depressed color="#F59E0B" dark>
                      <v-icon small left>mdi-pencil</v-icon>
                      Completar cadastro
                    </v-btn>
                  </div>
                </router-link>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div>
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-calendar</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">{{ inscricaoLocalizada.eventoNome }}</div>
                </div>
                
                <div style="display: flex; margin: 10px 0;">
                  <v-icon style="margin: 2px 12px 0 0; color: #6B7280;">mdi-map-marker</v-icon>
                  <div style="flex: 1; font-size: 15px; color: #374151;">
                    {{ inscricaoLocalizada.eventoLocal }}
                    <span v-if="inscricaoLocalizada.eventoLocalizacao">
                      (<a :href="inscricaoLocalizada.eventoLocalizacao" target="_blank" style="color: #2979FF; font-weight: 500;">Ver no mapa</a>)
                    </span>
                  </div>
                </div>
              </div>
              
              <v-divider style="margin: 20px 0; background-color: #E5E7EB;"></v-divider>
              
              <div style="display: flex; align-items: center; margin: 10px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-check-circle</v-icon>
                <span style="font-weight: 600; color: #1E3A8A;">Pagamento realizado com sucesso!</span>
              </div>
              
              <p style="font-size: 13px; color: #6B7280; margin: 12px 0; text-align: left;">
                Guarde este comprovante para sua referência.
              </p>
            </v-card-text>
            <v-card-actions v-if="inscricaoLocalizada.autopreenchimento" style="padding: 0; display: none; background-color: #FFFFFF;">
              <router-link :to="'/editinsc?cod=' + inscricaoLocalizada.cod_incricao" style="width: 100%">
                <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0">
                  <v-icon left>mdi-pencil</v-icon>
                  Clique aqui e complete seu cadastro para gerar o QR Code
                </v-btn>
              </router-link>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;" v-if="inscricaoLocalizada.eventoUsaCartaoConsumo">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#4B5563"
                :href="'https://aiconsumer.intelite.com.br?cod=' + inscricaoLocalizada.cod_incricao">
                <v-icon left>mdi-hanger</v-icon>
                Adquirir uniforme de treino
              </v-btn>
            </v-card-actions>
            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoIngressoIndividual = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoListaIngresso" persistent max-width="800px">
          <v-card style="border-radius: 12px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.1);">
            <div style="background-color: #2979FF; padding: 16px; text-align: center; border-radius: 10px 10px 0 0;">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon color="white" class="mr-2" size="24">mdi-ticket-confirmation</v-icon>
                <span style="color: white; font-weight: 600; font-size: 18px; letter-spacing: 0.5px;">Ingressos Digitais</span>
              </div>
            </div>

            <v-card-text style="padding: 24px 20px;">
              <div style="text-align: center; margin-bottom: 16px;">
                <h3 style="margin: 0 0 4px 0; color: #1E3A8A; font-size: 20px; font-weight: 600;">{{ eventoSelecionado.nome }}</h3>
                <div style="font-size: 15px; color: #64748B;">{{ eventoSelecionado.local }}</div>
              </div>

              <div v-if="inscricao.length > 0" style="margin-top: 20px; background-color: #F8FAFC; border-radius: 10px; padding: 16px 20px; border-left: 4px solid #2979FF;">
                <div style="font-weight: 500; color: #4B5563; font-size: 14px; margin-bottom: 10px; display: flex; align-items: center;">
                  <v-icon style="color: #2979FF;" class="mr-2">mdi-account-group</v-icon>
                  Lista de Ingressos ({{ inscricao.length }})
                </div>
                
                <div v-for="ingresso in inscricao" :key="ingresso.nome" style="border-radius: 8px; border: 1px solid #E0E7FF; margin: 10px 0; padding: 12px; background-color: white;">
                  <div style="display: flex; align-items: center;">
                    <div style="margin-right: 16px; min-width: 90px; text-align: center;">
                      <div style="padding: 8px; background-color: white; border-radius: 8px; display: inline-block; box-shadow: 0 2px 8px rgba(0,0,0,0.05); border: 1px solid #E0E7FF;">
                        <enhanced-qr-code :value="ingresso.cod_incricao" :size="70" :margin="1" :borderWidth="4" borderColor="#FFFFFF" :borderRadius="4"></enhanced-qr-code>
                      </div>
                    </div>
                    <div style="flex: 1;">
                      <p style="margin: 0 0 4px 0; font-size: 15px; font-weight: 600; color: #1E3A8A;">{{ ingresso.nome }}</p>
                      <p style="margin: 0 0 4px 0; font-size: 13px; color: #64748B;">{{ ingresso.cpf }}</p>
                      <p style="margin: 0; font-size: 13px; color: #64748B;">ID: <span style="font-weight: 500; color: #4B5563;">{{ ingresso.cod_incricao }}</span></p>
                      <v-chip x-small color="#2979FF" dark style="margin-top: 8px; height: 20px;">{{ ingresso.setor || 'Ingresso' }}</v-chip>
                    </div>
                    <div style="margin-left: 10px;">
                      <v-btn
                        small
                        elevation="0"
                        color="#1565C0"
                        style="text-transform: none; border-radius: 6px; font-weight: 500;"
                        @click="visualizarIngressoIndividual(ingresso)"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Visualizar
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else style="text-align: center; padding: 24px; background-color: #F9FAFB; border-radius: 8px; margin: 16px 0;">
                <v-icon size="48" color="#94A3B8" class="mb-2">mdi-ticket-off</v-icon>
                <p style="color: #64748B; font-size: 16px;">Nenhum ingresso encontrado para esse evento.</p>
                <div style="display: none">
                  <qrcode-vue :value="'exemplo'" :size="1" level="H" bg-color="white"></qrcode-vue>
                </div>
              </div>

              <div style="display: flex; align-items: center; margin: 24px 0 16px 0; padding: 12px; background-color: #F0F9FF; border-radius: 8px; border-left: 4px solid #2979FF;">
                <v-icon color="#2979FF" class="mr-3" size="22">mdi-information</v-icon>
                <span style="font-weight: 500; color: #1E3A8A; font-size: 14px;">Clique em "Visualizar" para ver os detalhes completos do ingresso.</span>
              </div>
            </v-card-text>

            <v-card-actions style="padding: 0 20px 20px 20px; background-color: #FFFFFF;">
              <v-btn style="border-radius: 8px; text-transform: none; height: 44px; font-weight: 500; letter-spacing: 0.3px;" dark depressed block color="#1565C0"
                @click="dialogoListaIngresso = false">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="380px">
          <v-card style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
            <div style="background-color: #FF9800; padding: 10px; text-align: center; border-radius: 10px 10px 0 0;">
              <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
              <span style="color: white; font-weight: bold;">{{ msgResultado }}</span>
            </div>
            <v-card-text style="padding: 16px;">
              <div style="text-align: center; margin-bottom: 8px;">
                <h3 style="margin: 0; color: #00695C; font-size: 16px;">{{ inscricao.nome }}</h3>
                <p style="margin: 4px 0; font-size: 13px; color: #757575;">{{ cultoSelecionado }}</p>
              </div>
              
              <v-divider class="my-2"></v-divider>
              
              <p style="margin: 8px 0; font-size: 13px; color: #F44336; font-weight: 500;">
                <v-icon small color="#F44336" class="mr-1">mdi-alert</v-icon>
                Fique atento! Após um dia útil, será enviada uma mensagem no WhatsApp do número informado com a confirmação de pagamento e o seu ingresso digital.
              </p>
              
              <v-btn style="border-radius: 7px; margin: 8px 0; text-transform: uppercase;" dark block color="primary" @click="abreBoleto">
                <v-icon left small>mdi-file-document-outline</v-icon>
                Visualizar Boleto
              </v-btn>
            </v-card-text>
            <v-card-actions style="padding: 0 16px 16px 16px;">
              <v-btn style="border-radius: 7px; text-transform: uppercase;" dark depressed block color="#7b4f44"
                @click="closeDialog">
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="380px">
          <v-card style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
            <div style="background-color: #FF9800; padding: 10px; text-align: center; border-radius: 10px 10px 0 0;">
              <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
              <span style="color: white; font-weight: bold;">{{ msgResultado }}</span>
            </div>
            <v-card-text style="padding: 16px;">
              <div style="text-align: center; margin-bottom: 8px;">
                <h3 style="margin: 0; color: #00695C; font-size: 16px;">{{ inscricao.nome }}</h3>
                <p style="margin: 4px 0; font-size: 13px; color: #757575;">{{ cultoSelecionado }}</p>
              </div>
              
              <v-divider class="my-2"></v-divider>
              
              <p style="margin: 8px 0; font-size: 13px; color: #F44336; font-weight: 500;">
                <v-icon small color="#F44336" class="mr-1">mdi-alert</v-icon>
                Sua inscrição foi pré-aprovada. Para confirmar, o pagamento deve ser feito em mãos.
              </p>
              
              <div style="background-color: #f5f5f5; border-left: 3px solid #00695C; padding: 8px; margin: 8px 0; border-radius: 4px;">
                <p style="margin: 0; font-size: 13px;">Guarde o número da sua inscrição. Ele será necessário para o pagamento.</p>
              </div>
            </v-card-text>
            <v-card-actions style="padding: 0 16px 16px 16px;">
              <v-btn style="border-radius: 7px; text-transform: uppercase;" dark depressed block color="#7b4f44"
                @click="closeDialog">
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{ inscricao.nome }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">CPF : {{ inscricao.cpf }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de
                      cancelamento</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C"
                @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      
        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 4px">
              <span class="texto" style="color: #00695c; font-weight: bold">{{ msgResultado }}</span>
            </v-card-title>

            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" style="padding: 10px">
                    <p class="texto" style="text-align: left; font-weight: bold;">
                      Copie este código para pagar <b style="color: orange">R$ {{(parseFloat(valorTotalCompra) + parseFloat(valorAcrescimo.acrescimoPix)).toFixed(2).replace(".", ",")}}</b>:
                    </p>
                    <ol style="text-align: left; padding-left: 16px; margin: 0;">
                      <li>Acesse seu app de pagamentos.</li>
                      <li>Escolha pagar via Pix.</li>
                      <li>Cole o seguinte código:</li>
                    </ol>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card flat class="d-flex justify-center pa-4" color="white">
                      <enhanced-qr-code
                          v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'"
                          :value="qrCode64"
                          :size="230"
                          :margin="1"
                          :borderWidth="8"
                          borderColor="#FFFFFF"
                          :borderRadius="6"
                      ></enhanced-qr-code>
                      <img
                        v-else-if="exibirQRCode"
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                    <v-text-field
                      v-model="chaveCopiaeCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      disable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#00695C"
                      dark
                      depressed
                      @click="doCopy('chavePix')"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Copiar código
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      text
                      color="#00695C"
                      dark
                      @click="exibirQRCode = !exibirQRCode"
                      style="border-radius: 10px; font-size: 14px; "
                    >
                      {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px;">
            <v-card-text style="text-align: center; padding:0 24px 0;">
              <v-container>
                <p><b>Enviamos um token para seu WhatsApp.<br>Por favor, informe-o abaixo para ter acesso ao seu
                    ingresso digital:</b></p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px;">
                    <v-text-field light v-mask="'####'" v-model="token" label="TOKEN" type="tel" single-line outlined
                      color="#00695C" dense hide-details required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn style="border-radius: 7px;" dark block depressed color="#00695C"
                  @click="confirmaToken">Confirmar</v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
/* import vueCard from 'vue-card-express'; */
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import CpfValidate from '../../componentes/validators/rules/cpf'
import CnpjValidate from '../../componentes/validators/rules/cnpj'
import QrcodeVue from 'qrcode.vue'
import EnhancedQrCode from '../../componentes/EnhancedQrCode.vue'
import { baseApiUrl, /* modelBoleto */ } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import {
  mapState
} from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: {
    Snackbar,
    QrcodeVue,
    EnhancedQrCode,
    Loading
  },
  name: 'Auth',

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,

    mascaraDocumento() {
      if (this.empresaCompra.cpfCnpj.length <= 14) {
        return '###.###.###-##'
      } else {
        return '##.###.###/####-##'
      }
    }
  }),

  data: function () {
    return {
      exibirQRCode: false,
      timeout: 4000,
      snackbar: false,
      textoSnackbar: '',
      pagamentoPix: false,
      localPagamento: '',
      eventoId: '',
      cpf: '',
      email: '',
      qtdCompra: 1,
      pagePrincipal: true,
      pagePagamento: false,
      pageConsulta: false,
      PageIncricao: false,
      maskCartao: "#### #### #### ####",
      user: {},
      cultoSelecionado: '',
      inscricao: [{
        cod_incricao: '',
        nome: '',
        cpf: '',
        email: '',
        sexo: '',
        telefone: '',
        eventoId: '',
        lote: 0,
        tipo: "VIRTUAL",
        nomeCracha: '',
        dataNascimento: '',
        tipoDocumento: '',
        valorPago: '',
        empresaNome: '',
        cargo: '',
        cnpj: '',
        cep: '',
        logradouro: '',
        estado: '',
        cidade: '',
        bairro: '',
        numero: ''
      }],
      inscricaoDefault: [{
        cod_incricao: '',
        nome: '',
        cpf: '',
        email: '',
        sexo: '',
        telefone: '',
        eventoId: '',
        lote: 0,
        tipo: "VIRTUAL",
        nomeCracha: '',
        dataNascimento: '',
        tipoDocumento: '',
        valorPago: '',
        empresaNome: '',
        cargo: '',
        cnpj: '',
        cep: '',
        logradouro: '',
        estado: '',
        cidade: '',
        bairro: '',
        numero: ''
      }],
      pagamento: {
        valor: 0,
        cartaoNumero: '',
        cvv: '',
        mesVencimento: '',
        anoVencimento: '',
        nomeTitular: '',
        cpfTitular: '',
        bandeira: '',
        cep: '',
        numero: '',
        email: ''
      },
      dialogCancelamento: false,
      dialogoIngressoIndividual: false,
      confirmacaoBoleto: false,
      confirmacaoEmMaos: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ['MASCULINO', 'FEMININO'],
      tipo: ['MEMBRO', 'VISITANTE'],
      tamanhos: ['PP', 'P', 'M', 'G', 'GG', 'XG'],
      quantidade: [],
      mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      anosVencimento: [],
      eventos: [],
      condicoes: [
        { value: true, text: 'SIM' },
        { value: false, text: 'NÃO' }
      ],
      necessidades: ['AUDITIVA', 'CADEIRANTE', 'VISUAL'],
      bandeiras: [
        { value: 'DINERS', text: "DINERS" },
        { value: 'ELO', text: "ELO" },
        { value: 'HIPERCARD', text: "HIPERCARD" },
        { value: 'MASTERCARD', text: "MASTERCARD" },
        { value: 'VISA', text: "VISA" }
      ],
      parcelas: [],
      modelCartao: {
        id: '',
        valor: '',
        tipoTransacao: 'A_VISTA',
        quantidadeParcelas: 1,
        comprador: {
          id: '',
          documentoNumero: '',
          documentoTipo: '1',
          email: '',
          nomeCompleto: '',
          primeiroNome: '',
          ultimoNome: '',
          enderecoLogradouro: '',
          enderecoNumero: '',
          enderecoComplemento: '',
          enderecoCep: '',
          enderecoBairro: '',
          enderecoCidade: '',
          enderecoEstado: '',
        },
        cartao: {
          numero: '',
          codigoSeguranca: '',
          nome: '',
          expiracaoAno: '',
          expiracaoMes: '',
          bandeira: ''
        }
      },
      cobrancaAsaas: {
        customer: '',
        billingType: '',
        value: 0,
        dueDate: '',
        description: ''
      },
      cobrancaAsaasCartao: {
        customer: '',
        billingType: '',
        value: 0,
        dueDate: '',
        description: '',
        remoteIp: '',
        creditCard: {
          holderName: '',
          number: '',
          expiryMonth: '',
          expiryYear: '',
          ccv: ''
        },
        creditCardHolderInfo: {
          name: '',
          email: '',
          cpfCnpj: '',
          postalCode: '',
          addressNumber: '',
          phone: ''
        }
      },
      clienteAsaas: {
        name: '',
        cpfCnpj: '',
        email: '',
        mobilePhone: '',
        postalCode: '',
        addressNumber: '',
        notificationDisabled: true,
      },
      tokenAsaas: '49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3',
      qrCode64: '',
      chaveCopiaeCola: '',
      valorParcela: 0,
      empresa: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      idInscricao: [],
      codigoAcesso: '',
      informaMunicipio: true,
      idClienteAsaas: '',
      valorAcrescimo: {
        acrescimoBoleto: 0.00,
        acrescimoPix: 0.00,
      },
      qtdInscMasculinas: 0,
      qtdInscFemininas: 0,
      vagasMasculinas: 0,
      vagasFemininas: 0,
      textoParcela: '',
      paginaInscricaoGrupo: false,
      caravana: false,
      inscricaoLocalizada: {
        cod_incricao: '',
        nome: '',
        email: '',
        sexo: '',
        telefone: '',
        eventoNome: '',
        eventoLocal: '',
        eventoLocalizacao: '',
        eventoUsaCartaoConsumo: '',
        setor: '',
        corSetor: ''
      },
      linkBoleto: '',
      consultaCPF: false,
      dialogoToken: false,
      token: '',
      divulgador: null,
      indicacao: false,
      possuiCupom: false,
      cupomDesconto: '',
      cupomAplicado: false,
      loader: null,
      loadingCupom: false,
      dadosCupom: [],
      qtdParcelas: null,
      usaCupomDesconto: null,
      tipoIngresso: '',
      eventoSelecionado: [],
      usaCartaoConsumo: null,
      bloqueiaVoltar: false,
      estados: [],
      municipios: [],
      tiposDocumento: ["CPF", "CNPJ"],
      valorTotalCompra: 0,
      aceiteLgpd: false,
      dialogoListaIngresso: false,
      empresaCompra: {
        cpfCnpj: '',
        nome: '',
        telefone: '',
        email: '',
        cep: '',
        logradouro: '',
        estado: '',
        cidade: '',
        bairro: '',
        numero: null,
      },
      defaultEmpresaCompra: {
        cpfCnpj: '',
        nome: '',
        telefone: '',
        email: '',
        cep: '',
        logradouro: '',
        estado: '',
        cidade: '',
        bairro: '',
        numero: null,
      },
      exibePreenchimento: false,
      dictionary: {
        custom: {
          nomeCartao: {
            required: () => 'Informe o nome'
          },
          numCartao: {
            required: () => 'Informe o número do cartão de crédito',
          },
          cpftitular: {
            required: () => 'Informe o número do cartão de crédito',
          },
          codCartao: {
            required: () => 'Informe o código de segurança'
          },
          expiraCartaoMes: {
            required: () => 'Informe o mês de validade do cartão',
          },
          expiraCartaoAno: {
            required: () => 'Informe o ano de validade do cartão',
          },
          dateOfBirth: {
            required: () => 'Informe a Data de Nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      cepNotCaptured: false
    }
  },

  mounted: async function () {
    await this.carregaDados()
    this.pegaParametrosUrl()
    this.$validator.localize('pt', this.dictionary)
    // this.buscaUfs()
    // this.buscaMunicipios()
  },

  watch: {
    dialogoIngressoIndividual(val) {
      if (val == false) {
        setTimeout(() => {
          let keys = Object.keys(this.inscricaoLocalizada)

          for (let i = 0; i < keys.length; i++) {
            this.inscricaoLocalizada[keys[i]] = ''
          }
        }, 300)
      }
    },

    dialogoListaIngresso(val) {
      if (val == false) {
        this.inscricao = Object.assign({}, this.inscricaoDefault)
        this.pagePrincipal = true
        this.paginaInscricaoGrupo = false
        this.pagePagamento = false
        this.idInscricao = []
      }
    },

    qtdCompra(val) {
      // Ajusta automaticamente para 6 se selecionar 5
      if (val === 5) {
        this.$nextTick(() => {
          this.qtdCompra = 6
        })
      }
      // Ajusta automaticamente para 10 se selecionar 8 ou 9
      else if (val === 8 || val === 9) {
        this.$nextTick(() => {
          this.qtdCompra = 10
        })
      }
    }
  },

  methods: {
    retornaMunicipios(uf) {
      return this.municipios.filter(municipios => municipios['UF-sigla'] === uf)
    },

    criarQuantidades(quantidade) {
      this.quantidade = []

      for (let i = 0; i < 15; i++) {
        if (i >= quantidade) { 
          this.quantidade.push(i)
        }
      }
    },

    calculaParcelas(evento, qtdCompra) {
      let valorTotal

      if (qtdCompra) {
        valorTotal = (parseFloat(evento.valorCartao.replace(",", ".") * evento.vendaMinima) + parseFloat(evento['acrescimoCartao' + evento.quantidadeParcelas].replace(",", ".") * evento.vendaMinima))
        valorTotal = valorTotal * qtdCompra
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
      } else {
        valorTotal = (parseFloat(evento.valorCartao.replace(",", ".") * evento.vendaMinima) + parseFloat(evento['acrescimoCartao' + evento.quantidadeParcelas].replace(",", ".") * evento.vendaMinima))
        valorTotal = parseFloat(valorTotal / evento.quantidadeParcelas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
      }
      return valorTotal
    },

    preencherInformacoes(indice) {
      let answer = confirm(
        "Deseja preencher os dados desta inscrição com os dados da primeira inscrição?"
      );

      if (answer) {
        this.inscricao[indice].cpf = this.inscricao[0].cpf;
        this.inscricao[indice].nome = this.inscricao[0].nome + " " + (indice + 1);
        this.inscricao[indice].email = this.inscricao[0].email;
        this.inscricao[indice].telefone = this.inscricao[0].telefone;
        this.inscricao[indice].sexo = this.inscricao[0].sexo;
        this.inscricao[indice].telefone = this.inscricao[0].telefone;
        this.inscricao[indice].nomeCracha = this.inscricao[0].nomeCracha;
        this.inscricao[indice].tipoDocumento = this.inscricao[0].tipoDocumento;
        this.inscricao[indice].empresaNome = this.inscricao[0].empresaNome;
        this.inscricao[indice].cargo = this.inscricao[0].cargo;
        this.inscricao[indice].cnpj = this.inscricao[0].cnpj;
        this.inscricao[indice].cep = this.inscricao[0].cep;
        this.inscricao[indice].logradouro = this.inscricao[0].logradouro;
        this.inscricao[indice].estado = this.inscricao[0].estado;
        this.inscricao[indice].cidade = this.inscricao[0].cidade;
        this.inscricao[indice].bairro = this.inscricao[0].bairro;
        this.inscricao[indice].numero = this.inscricao[0].numero;
        this.inscricao[indice].dataNascimento = this.inscricao[0].dataNascimento
      }
    },

    criarAnosVencimento() {
      this.anosVencimento = []
      let anoAtual = new Date().toISOString().substring(0, 4)
      let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

      while (anoAtual <= anoFinal) {
        this.anosVencimento.push((anoAtual++).toString());
      }
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar = true
        this.textoSnackbar = 'Chave copiada para a área de transferência!'
      } catch (error) {
        this.snackbar = true
        this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
      }
    },

    reloadPage() {
      window.location.reload()
    },

    async carregaDados() {
      this.eventos = []
      this.isLoading = true

      await axios.post(baseApiUrl + 'eventos/eventosFuturos', { "empresaId": "67dd7b86a026827c1ebdf30a" })
        .then(async response => {
          this.eventos = response.data.eventos
          this.empresa = response.data.empresa
          this.isLoading = false
        })
    },

    criarParcelas(valor) {
      this.parcelas = []

      for (let i = 0; i < this.qtdParcelas; i++) {
        // incrementa o índice do for para usar como número da parcela
        let numeroParcela = (i + 1)

        // multiplicação do valor de acréscimo com a quantidade de inscrições
        let valorAcrescimo = parseFloat(this.valorAcrescimo['acrescimoCartao' + numeroParcela].replace(',', '.')) * this.inscricao.length

        // soma valor da compra com o valor de acréscimo
        let valorTotal = parseFloat(valor) + valorAcrescimo

        // divide o valor total pelo número da parcela
        let valorParcela = valorTotal / numeroParcela

        let textoParcela = numeroParcela + 'X de R$ ' + valorParcela.toFixed(2).replace('.', ',') + ' (Total R$ ' + valorTotal.toFixed(2).replace('.', ',') + ')'

        this.parcelas.push(textoParcela)
      }
    },

    cancelarPagamento() {
      //this.removeCupom()
      this.pagePagamento = false
      if (this.caravana) {
        this.paginaInscricaoGrupo = true
      } else {
        this.PageIncricao = true
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        this.inscricao[i].autopreenchimento = undefined
      }
    },

    /* formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }, */

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 5) + 'h';
    },

    async acessaConsulta() {
      this.pagePrincipal = false
      this.pageConsulta = true
    },

    async solicitaCancelamento() {
      this.pagePrincipal = false
      this.pageConsulta = true
      if (this.inscricao.nome == '' || this.eventoId == '' || this.inscricao.cpf == '') {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
      } else {
        this.isLoading = false
        this.dialogCancelamento = true
      }
    },

    async realizarCancelamento() {
      this.idInscricao = ''
      this.isLoading = true
      try {
        let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`)
        if (res.data[0].id) {
          this.idInscricao = res.data[0].id
        } else {
          this.isLoading = false
          this.dialogCancelamento = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }
      } catch (error) {
        this.isLoading = false
        this.dialogCancelamento = false
        vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
      }
      if (this.idInscricao != '') {
        try {
          let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idInscricao}`)
          if (res.data != '') {
            this.isLoading = false
            this.inscricao = Object.assign({}, this.inscricaoDefault)
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")
          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
        }
      }
    },

    async aplicaCupom() {
      var vm = this;

      if (this.cupomDesconto) {
        await axios.get(baseApiUrl + 'Cupons?filter={"where":{"nome":"' + this.cupomDesconto.toUpperCase().trim() + '"}}')
          .then(response => {
            if (response.data) {
              if (response.data[0].nome.toUpperCase() == this.cupomDesconto.toUpperCase().trim() && response.data[0].quantidade > response.data[0].utilizados) {
                this.dadosCupom = response.data[0]
                this.cupomAplicado = true
                this.valorTotalCompra = (parseFloat(parseFloat(this.valorTotalCompra) - parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.', ',')
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#F9A825", "Cupom inválido ou esgotado!", "ATENÇÃO")
          })
      }
    },

    removeCupom() {
      this.valorTotalCompra = (parseFloat(parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.', ',')
      this.cupomAplicado = false
      this.dadosCupom = []
      this.possuiCupom = false
      this.cupomDesconto = ''
    },

    async atualizaCupomsUtilizados() {
      await axios.patch(baseApiUrl + 'Cupons/' + this.dadosCupom.id, { "utilizados": this.dadosCupom.utilizados + 1 })
    },

    carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(this.parcelas[i].split('X')[0])
          this.textoParcela = this.parcelas[i]
          this.pagamento.valor = this.parcelas[i].match(/\(Total R\$ ([\d,]+)\)/)[1].replace(',', '.')
          break
        }
      }
    },

    async prosseguirPagamento(formaPagamento) {
      let vm = this
      let inscricoesValidas = []
      await this.pegaVagasDisponiveis()

      if (!this.exibePreenchimento) {
        await this.preencheInscricoes()
      }

      if (!this.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais", "ATENÇÃO")
        return
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        this.inscricao[i].setor = this.eventoSelecionado.setores[0].nome
        this.inscricao[i].corSetor = this.eventoSelecionado.setores[0].cor

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (this.inscricao[i].tipoDocumento == 'CPF' && !this.validarCamposInscricaoCPF(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todos os campos corretamente do ' + (i + 1) + 'º participante para confirmar a inscrição!', "ATENÇÃO")
          break
        }
        else if (this.inscricao[i].tipoDocumento == 'CNPJ' && !this.validarCamposInscricaoCNPJ(this.inscricao[i])) {
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todos os campos corretamente do ' + (i + 1) + 'º participante para confirmar a inscrição!', "ATENÇÃO")
          break
        }
        else {
          if (this.vagasDisponiveis[this.inscricao[i].setor] > 0) {
            inscricoesValidas.push(this.inscricao[i])
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825", 'Quantidade máxima do setor selecionado para o ' + (i + 1) + 'º participante foi atingido. Selecione outro setor.', "ATENÇÃO")
            break
          }
        }
      }

      if (inscricoesValidas.length === this.inscricao.length) { 
        let valorPagamento

        if (this.indicacao && this.divulgador.aplicaDesconto && this.divulgador.valorDesconto && this.eventoSelecionado.usaLinkDesconto) {
          valorPagamento = this.valorTotalCompra - (this.valorTotalCompra * this.divulgador.valorDesconto / 100)
        } else {
          valorPagamento = this.valorTotalCompra
        }

        if (formaPagamento == 'CARTÃO') {
          this.criarAnosVencimento()
          this.criarParcelas(valorPagamento)
          this.pagamento.email = this.inscricao[0].email
          this.paginaInscricaoGrupo = false
          this.pagePagamento = true;
        } else if (formaPagamento == 'PIX') {
          this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago(valorPagamento) : this.pagarPixAsaas(valorPagamento)
        } else if (formaPagamento == 'BOLETO') {
          this.pagamentoBoleto()
        }
      }
    },

    validarCamposInscricaoCPF(inscricao) {
      if (
        inscricao.nome.trim() === '' ||
        inscricao.cpf.trim() === '' ||
        !CpfValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === '' ||
        this.empresaCompra.cpfCnpj.trim() === '' ||
        this.empresaCompra.nome.trim() === '' ||
        this.empresaCompra.telefone.trim() === '' ||
        this.empresaCompra.email.trim() === '' ||
        this.empresaCompra.cep.trim() === '' ||
        this.empresaCompra.logradouro.trim() === '' ||
        this.empresaCompra.estado.trim() === '' ||
        this.empresaCompra.cidade.trim() === '' ||
        this.empresaCompra.bairro.trim() === '' ||
        this.empresaCompra.numero.trim() === ''
      ) {
        return false
      } else {
        return true
      }
    },

    validarCamposInscricaoCNPJ(inscricao) {
      if (
        inscricao.nome.trim() === '' ||
        inscricao.cpf.trim() === '' ||
        !CnpjValidate(inscricao.cpf) ||
        inscricao.sexo.trim() === '' ||
        inscricao.telefone.trim() === '' ||
        inscricao.email.trim() === '' ||
        inscricao.dataNascimento.trim() === '' ||
        inscricao.nomeCracha.trim() === '' ||
        inscricao.valorPago.trim() === '' ||
        inscricao.empresaNome.trim() === '' ||
        inscricao.cargo.trim() === '' ||
        inscricao.cnpj.trim() === '' ||
        inscricao.cep.trim() === '' ||
        inscricao.logradouro.trim() === '' ||
        inscricao.estado.trim() === '' ||
        inscricao.cidade.trim() === '' ||
        inscricao.bairro.trim() === '' ||
        inscricao.numero.trim() === ''
      ) {
        return false
      } else {
        return true
      }
    },

    preencheInscricoes() {
      for (let i = 0; i < this.inscricao.length; i++) {
        this.inscricao[i].cpf = this.empresaCompra.cpfCnpj
        this.inscricao[i].nome = this.empresaCompra.nome ? this.empresaCompra.nome + ' ' + (i + 1) : ''
        this.inscricao[i].telefone = this.empresaCompra.telefone
        this.inscricao[i].email = this.empresaCompra.email
        this.inscricao[i].autopreenchimento = true
      }
    },

    async realizarInscricaoPagamento() {
      this.isLoading = true
      this.jaExiste = false
      var camposBranco = false
      this.inscricao.eventoId = this.eventoId
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.criarAnosVencimento()
            this.criarParcelas()
            this.isLoading = false
            this.pagePrincipal = false;
            this.paginaInscricaoGrupo = false
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        } else {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.criarAnosVencimento()
            this.criarParcelas()
            this.isLoading = false
            this.pagePrincipal = false;
            this.PageIncricao = false
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        }
      }
    },

    async realizarInscricaoPagamentoBoleto() {
      this.isLoading = true
      this.jaExiste = false
      var camposBranco = false
      this.inscricao.eventoId = this.eventoId
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.pagamentoBoleto()
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        } else {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.pagamentoBoleto()
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        }
      }
    },

    async realizarInscricaoPagamentoEmMaos() {
      this.isLoading = true
      this.jaExiste = false
      var camposBranco = false
      this.inscricao.eventoId = this.eventoId
      if (await this.validaVagas()) {
        if (this.inscricao.dataNascimento != '' && this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16) {
          this.isLoading = false
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack("#F9A825", "Só é permitido a inscrição de maiores de 16 anos!", "ATENÇÃO")
        }
        else {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf)) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.inscricao.statusPagamento = 'PENDENTE'
            this.inscricao.formOfPayment = 'EM MAOS'
            this.inscricao.valorPago = '330,00'
            this.realizarInscricao(this.finalizaInscricao)
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        }
      }
    },


    async realizarInscricaoPagamentoPix() {
      this.isLoading = true
      this.jaExiste = false
      var camposBranco = false
      this.inscricao.eventoId = this.eventoId
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        } else {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
          }
          if (this.inscricao.length == 0)
            this.isLoading = false
        }
      }
    },

    realizarInscricaoAgora() {
      this.pagePrincipal = false;
      this.PageIncricao = true
      this.validaVagas()
      this.verificaCapacidade()
    },

    async realizarInscricaoGrupo(evento) {
      this.tipoIngresso = evento.nome
      this.caravana = true
      this.pagePrincipal = false;
      this.paginaInscricaoGrupo = true

      this.empresaCompra = Object.assign({}, this.defaultEmpresaCompra)
      this.inscricao = []
      for (let i = 0; i < evento.vendaMinima; i++) {
        this.inscricao.push({
          cod_incricao: '',
          nome: '',
          cpf: '',
          email: '',
          sexo: '',
          telefone: '',
          eventoId: '',
          lote: '',
          tipo: "VIRTUAL",
          estado: '',
          cidade: '',
          tipoDocumento: evento.tipoDocumento == 'AMBOS' ? this.tiposDocumento[0] : evento.tipoDocumento,
          valorPago: '',
          dataNascimento: '',
        })
      }

      this.eventoSelecionado = evento
      this.eventoId = evento.id

      let keys = Object.keys(evento)
      keys = keys.filter(k => k.includes('acrescimoCartao'))

      for (let i = 0; i < evento.quantidadeParcelas; i++) {
        if (keys[i]) {
          this.valorAcrescimo[keys[i]] = evento[keys[i]]
        }
        else {
          this.valorAcrescimo['acrescimoCartao' + (i + 1)] = "0,00"
        }
      }

      this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto
      this.valorAcrescimo.acrescimoPix = evento.acrescimoPix
      this.qtdParcelas = evento.quantidadeParcelas
      this.usaCupomDesconto = evento.usaCupomDesconto
      this.criarQuantidades(evento.vendaMinima)
      this.qtdCompra = evento.vendaMinima
      // await this.verificaCapacidade()

      for (let i = 0; i < this.inscricao.length; i++) {
        if (evento.tipoDocumento == 'AMBOS') {
          this.inscricao[i].tipoDocumento = this.tiposDocumento[0]
        } else {
          this.inscricao[i].tipoDocumento = evento.tipoDocumento
        }
      }

      this.valorTotalCompra = 0

      if (this.empresa.limiteInscricao == 'SETOR') {
        this.pegaVagasDisponiveis()
      }

      this.calculaValorCompra()
    },

    async verificaDocumento(cpf, index, tipo) {
      let vm = this
      let jaExiste = false

      if ((tipo == 'CNPJ' && !CnpjValidate(cpf) || (tipo == 'CPF' && !CpfValidate(cpf)))) {
        return
      }

      if (this.verificaCpfInformado(cpf, index)) {
        jaExiste = true
        this.inscricao[index].cpf = ''
        vm.$refs.chamaSnackbar.snack("#F9A825", "CPF não pode ser o mesmo de um já informado!", "ATENÇÃO")
      }

      if (!jaExiste) {
        await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCPF', { "cpf": cpf, "eventoId": this.eventoSelecionado.id })
          .then(response => {
            if (response.data.length > 0) {
              /*               if (Object.keys(response.data[0]).includes('statusPagamento')) {
                              if (response.data[0].statusPagamento == 'PAGO') {
                                // exibir diálogo com QR Code do ingresso
                                this.inscricao[index].cpf = ''
                                this.inscricaoLocalizada = Object.assign({}, response.data[0])
                                this.dialogoIngressoIndividual = true
                              } else if (response.data[0].statusPagamento == 'PENDENTE') { */
              this.inscricao[index].nomeCracha = response.data[0].nomeCracha
              this.inscricao[index].cod_incricao = response.data[0].cod_incricao
              this.inscricao[index].cpf = response.data[0].cpf
              this.inscricao[index].nome = response.data[0].nome
              this.inscricao[index].sexo = response.data[0].sexo
              this.inscricao[index].telefone = response.data[0].telefone
              this.inscricao[index].email = response.data[0].email
              this.inscricao[index].dataNascimento = response.data[0].dataNascimento
              this.inscricao[index].cep = response.data[0].cep
              this.inscricao[index].estado = response.data[0].estado
              this.inscricao[index].cidade = response.data[0].cidade
              this.inscricao[index].valorPago = response.data[0].valorPago
              this.inscricao[index].tipoDocumento = response.data[0].tipoDocumento
              this.inscricao[index].id = response.data[0].id
              /*  }
             } else {
               this.inscricao[index].nome = response.data[0].nome ? response.data[0].nome : ''
               this.inscricao[index].cpf = response.data[0].cpf ? response.data[0].cpf : ''
               this.inscricao[index].dataNascimento = response.data[0].dataNascimento ? response.data[0].dataNascimento : ''
               this.inscricao[index].telefone = response.data[0].telefone ? response.data[0].telefone : ''
               this.inscricao[index].email = response.data[0].email ? response.data[0].email : ''
             } */
            }
          })
      }
    },

    verificaCpfInformado(cpf, indice) {
      let cpfLocalizado = false

      for (let i = 0; i < this.inscricao.length; i++) {
        if (i != indice) {
          if (this.inscricao[i].cpf == cpf) {
            cpfLocalizado = true
            break
          }
        }
      }

      return cpfLocalizado
    },

    async validaVagas() {
      var vm = this;

      try {
        await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"' + this.eventoId + '"},{"sexo":"MASCULINO"}]}').then(response => {
          if (response.data) {
            this.qtdInscMasculinas = response.data.count
          }
        })
        await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"' + this.eventoId + '"},{"sexo":"FEMININO"}]}').then(response => {
          if (response.data) {
            this.qtdInscFemininas = response.data.count
          }
        })
        /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
        if (res.data.length > 0)
          res.data.forEach(insc => {
            if (insc.sexo == 'MASCULINO')
              this.qtdInscMasculinas = this.qtdInscMasculinas + 1
            else if (insc.sexo == 'FEMININO')
              this.qtdInscFemininas = this.qtdInscFemininas + 1
          }); */

        if (this.inscricao.sexo == 'MASCULINO') {
          //this.qtdInscMasculinas = this.vagasMasculinas
          if (this.qtdInscMasculinas == this.vagasMasculinas) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para homens foram esgotadas!", "INFORMAÇÃO")
            return false
          } else {
            this.isLoading = false
            return true
          }
        } else if (this.inscricao.sexo == 'FEMININO') {
          if (this.qtdInscFemininas == this.vagasFemininas) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para mulheres foram esgotadas!", "INFORMAÇÃO")
            return false
          } else {
            this.isLoading = false
            return true
          }
        } else {
          this.isLoading = false
          return true
        }
      } catch (error) {
        //
      }
    },

    async realizarInscricao(callback = null, formaPagamento, textoParcela) {
      this.isLoading = true
      let vm = this

      for (let i = 0; i < this.inscricao.length; i++) {
        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao[i].cod_incricao) {
          this.inscricao[i].cod_incricao = await this.verificaCodInscricao()
        }

        this.inscricao[i].eventoId = this.eventoSelecionado.id
        this.inscricao[i].statusPagamento = "PENDENTE"
        this.inscricao[i].empresaId = this.empresa.id
        this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim()
        this.inscricao[i].formOfPayment = formaPagamento
        this.inscricao[i].parcelas = textoParcela
        this.inscricao[i].divulgadorId = this.indicacao ? this.divulgador.id : undefined
        this.inscricao[i].lote = this.eventoSelecionado.lote
        this.inscricao[i].cnpj = this.empresaCompra.cpfCnpj
        this.inscricao[i].cep = this.empresaCompra.cep
        this.inscricao[i].logradouro = this.empresaCompra.logradouro
        this.inscricao[i].estado = this.empresaCompra.estado
        this.inscricao[i].cidade = this.empresaCompra.cidade
        this.inscricao[i].bairro = this.empresaCompra.bairro
        this.inscricao[i].numero = this.empresaCompra.numero
        this.inscricao[i].bairro = this.empresaCompra.bairro
        
        // Atribuir valorPago conforme a forma de pagamento
        if (formaPagamento == "CARTAO") {
          this.inscricao[i].valorPago = this.eventoSelecionado.valorCartao;
        } else if (formaPagamento == "PIX") {
          this.inscricao[i].valorPago = this.eventoSelecionado.valorPix;
        } else if (formaPagamento == "BOLETO") {
          this.inscricao[i].valorPago = this.eventoSelecionado.valorBoleto || this.eventoSelecionado.valor;
        } else {
          this.inscricao[i].valorPago = this.eventoSelecionado.valor;
        }
      }

      // Adicionar ingressos bônus se necessário
      if (this.qtdCompra === 5) {
        // Adiciona 1 ingresso bônus
        this.inscricao.push({
          cod_incricao: await this.verificaCodInscricao(),
          nome: this.empresaCompra.nome + ' (Bônus)',
          cpf: this.empresaCompra.cpfCnpj,
          email: this.empresaCompra.email,
          telefone: this.empresaCompra.telefone,
          eventoId: this.eventoSelecionado.id,
          statusPagamento: "PENDENTE",
          empresaId: this.empresa.id,
          formOfPayment: formaPagamento,
          parcelas: textoParcela,
          divulgadorId: this.indicacao ? this.divulgador.id : undefined,
          lote: this.eventoSelecionado.lote,
          cnpj: this.empresaCompra.cpfCnpj,
          cep: this.empresaCompra.cep,
          logradouro: this.empresaCompra.logradouro,
          estado: this.empresaCompra.estado,
          cidade: this.empresaCompra.cidade,
          bairro: this.empresaCompra.bairro,
          numero: this.empresaCompra.numero,
          tipoDocumento: this.inscricao[0].tipoDocumento,
          valorPago: formaPagamento == "CARTAO" ? this.eventoSelecionado.valorCartao : 
                    formaPagamento == "PIX" ? this.eventoSelecionado.valorPix : 
                    formaPagamento == "BOLETO" ? (this.eventoSelecionado.valorBoleto || this.eventoSelecionado.valor) : 
                    this.eventoSelecionado.valor
        })
      } else if (this.qtdCompra === 8) {
        // Adiciona 2 ingressos bônus
        for (let i = 0; i < 2; i++) {
          this.inscricao.push({
            cod_incricao: await this.verificaCodInscricao(),
            nome: this.empresaCompra.nome + ' (Bônus ' + (i+1) + ')',
            cpf: this.empresaCompra.cpfCnpj,
            email: this.empresaCompra.email,
            telefone: this.empresaCompra.telefone,
            eventoId: this.eventoSelecionado.id,
            statusPagamento: "PENDENTE",
            empresaId: this.empresa.id,
            formOfPayment: formaPagamento,
            parcelas: textoParcela,
            divulgadorId: this.indicacao ? this.divulgador.id : undefined,
            lote: this.eventoSelecionado.lote,
            cnpj: this.empresaCompra.cpfCnpj,
            cep: this.empresaCompra.cep,
            logradouro: this.empresaCompra.logradouro,
            estado: this.empresaCompra.estado,
            cidade: this.empresaCompra.cidade,
            bairro: this.empresaCompra.bairro,
            numero: this.empresaCompra.numero,
            tipoDocumento: this.inscricao[0].tipoDocumento,
            valorPago: formaPagamento == "CARTAO" ? this.eventoSelecionado.valorCartao : 
                      formaPagamento == "PIX" ? this.eventoSelecionado.valorPix : 
                      formaPagamento == "BOLETO" ? (this.eventoSelecionado.valorBoleto || this.eventoSelecionado.valor) : 
                      this.eventoSelecionado.valor
          })
        }
      }

      for (let j = 0; j < this.inscricao.length; j++) {
        this.inscricao[j].inscricaoPai = this.inscricao[0].cod_incricao
      }

      await axios.post(baseApiUrl + 'inscricoes/criarInscricoes', this.inscricao)
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            for (let j = 0; j < this.inscricao.length; j++) {
              if (this.inscricao[j].cpf == response.data[i].cpf) {
                this.idInscricao.push(response.data[i].id)
                this.inscricao[j].id = response.data[i].id
              }
            }
          }

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
        })
    },

    async verificaCodInscricao() {
      let codInscricao = new Date().getTime().toString()
      let codigoRetornado

      await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCodigo', { "cod_incricao": codInscricao })
        .then(async response => {
          if (response.data) {
            await this.verificaCodInscricao()
          }
        })
        .catch(error => {
          if (error.response.data.error.message.includes('não localizada')) {
            codigoRetornado = codInscricao
          }
        })

      return codigoRetornado
    },

    async atualizaInscricao(callback = null) {
      this.inscricao.id = this.idInscricao
      try {
        await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao)
        if (callback) {
          callback()
        }
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE")
      }
    },

    async enviaEmail() {
      try {
        await axios.post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, { "inscricaoId": this.idInscricao }).then(res => {
          if (res.data) {
            this.codigoAcesso = res.data.codigoAcesso
          }
        })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
      }
    },

    async realizarConsulta() {
      if (this.cpf == '') {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para realizar a consulta!", "ATENÇÃO")
      } else {
        this.isLoading = true
        var cpfSemMascara = this.cpf.replaceAll('.', '').replaceAll('-', '')
        await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`).then(res => {
          if (res.data != '') {
            if (res.data[0].statusPagamento == "PENDENTE") {
              this.msgResultado = 'Inscrição localizada'
              this.cultoSelecionado = this.eventos[0].nome
              this.isLoading = false
              this.inscricao.nome = res.data[0].nome
              this.inscricao.cpf = res.data[0].cpf
              this.inscricao.email = res.data[0].email
              this.inscricao.ddd = res.data[0].ddd
              this.inscricao.telefone = res.data[0].telefone
              this.inscricao.sexo = res.data[0].sexo
              this.inscricao.participantes = res.data[0].participantes
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.", "ATENÇÃO")
            } else {
              if (res.data[0].statusPagamento == "PAGO") {
                this.cultoSelecionado = this.eventos[0].nome
                this.inscricao.nome = res.data[0].nome
                this.inscricao.cod_incricao = res.data[0].cod_incricao
                this.inscricao.email = res.data[0].email
                this.inscricao.participantes = res.data[0].participantes
                this.dialogoIngressoIndividual = true
                this.isLoading = false
              }
            }
          } else {
            this.isLoading = false
            vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825", "Não foi localizada inscrição para os dados informados!", "ATENÇÃO")
          }
        })
      }
    },

    async consultaInscricaoPendente(cpf, indice) {
      this.isLoading = true

      await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"and":[{"eventoId":"' + this.eventoId + '"},{"cpf":"' + cpf + '"}]},"include":"evento"}')
        .then(response => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true
              this.msgResultado = 'Inscrição localizada'
              this.cultoSelecionado = this.eventos[0].nome
              this.isLoading = false
              this.inscricao[indice].cod_incricao = response.data[0].cod_incricao
              this.inscricao[indice].nome = response.data[0].nome
              this.inscricao[indice].cpf = response.data[0].cpf
              this.inscricao[indice].email = response.data[0].email
              this.inscricao[indice].sexo = response.data[0].sexo
              this.inscricao[indice].telefone = response.data[0].telefone
              this.inscricao[indice].eventoId = response.data[0].eventoId
              this.inscricao[indice].codigoTransacao = response.data[0].codigoTransacao
              this.inscricao[indice].estado = response.data[0].estado
              this.inscricao[indice].cidade = response.data[0].cidade
              this.inscricao[indice].id = response.data[0].id
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.", "ATENÇÃO")
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao
              this.cultoSelecionado = response.data[0].evento.nome
              this.inscricao.participantes = response.data[0].participantes
              this.inscricao.nome = response.data[0].nome
              this.codigoAcesso = response.data[0].codigoAcesso
              this.inscricao.email = response.data[0].email
              this.dialogoIngressoIndividual = true
              this.isLoading = false
            }
          } else {
            this.isLoading = false
            this.consultaDadosCpf(cpf)
          }
        })
    },

    async consultaDadosCpf(cpf) {
      await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"' + cpf + '"}}')
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim()
            this.inscricao.dataNascimento = response.data[0].dataNascimento
            this.inscricao.telefone = response.data[0].telefone
          }
        })
    },

    async verificaCapacidade() {
      // Ajusta automaticamente para 6 se selecionar 5
      if (this.qtdCompra === 5) {
        this.qtdCompra = 6
      }
      // Ajusta automaticamente para 10 se selecionar 8 ou 9
      else if (this.qtdCompra === 8 || this.qtdCompra === 9) {
        this.qtdCompra = 10
      }

      this.inscricao = []
      for (let i = 0; i < this.qtdCompra; i++) {
        this.inscricao.push({
          cod_incricao: '',
          nome: '',
          cpf: '',
          email: '',
          sexo: '',
          telefone: '',
          eventoId: '',
          lote: '',
          tipo: "VIRTUAL",
          estado: '',
          cidade: '',
          tipoDocumento: this.eventoSelecionado.tipoDocumento == 'AMBOS' ? this.tiposDocumento[0] : this.eventoSelecionado.tipoDocumento,
          valorPago: '',
          dataNascimento: '',
        })
      }

      if (this.empresa.limiteInscricao == 'SETOR') {
        await this.pegaVagasDisponiveis()
      }

      this.calculaValorCompra()
    },

    removerElementos(lista, quantidade) {
      if (lista.length >= quantidade) {
        lista.splice(-quantidade, quantidade);

        return lista
      }
    },

    calculaValorCompra() {
      let valorBase = parseFloat(this.eventoSelecionado.valor.replace(',', '.'))
      let valorTotal = valorBase * this.qtdCompra
      
      // Aplica desconto de 1 ingresso se comprar 6
      if (this.qtdCompra === 6) {
        valorTotal = valorTotal - valorBase
      }
      // Aplica desconto de 2 ingressos se comprar 10
      else if (this.qtdCompra === 10) {
        valorTotal = valorTotal - (valorBase * 2)
      }
      
      // Aplica desconto do divulgador se houver
      if (this.indicacao && this.divulgador.aplicaDesconto && this.eventoSelecionado.usaLinkDesconto) {
        valorTotal = valorTotal - (valorTotal * this.divulgador.valorDesconto / 100)
      }
      
      this.valorTotalCompra = valorTotal.toFixed(2).replace('.', ',')
    },

    async verificaVagas() {
      var vm = this;
      await axios.post(`${baseApiUrl}eventos/vagas`, { "eventoId": this.eventoId }).then(response => {
        if (response.data) {
          if (this.caravana) {
            if (response.data.vagasRestantes < 2) {
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
              return false
            } else if (response.data.vagasRestantes < this.inscricao.participantes) {
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, restam apenas " + (response.data.vagasRestantes) + " vaga(s) disponível(is)!", "INFORMAÇÃO")
              return false
            }
          } else {
            if (response.data.vagasRestantes == 0) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
              return false
            }
          }
          return true
        }
      })
    },

    // método de pagamento
    /* async pagarCartao() {
      if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
          this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
          this.modelCartao.tipoTransacao = 'A_VISTA'
          this.inscricao.valorPago = this.valorEvento
          this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
          //dados do comprador
          this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
          this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          this.modelCartao.comprador.documentoTipo = '1'
          this.modelCartao.comprador.email = this.inscricao.email
          this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
          this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
          this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
          this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
          this.modelCartao.comprador.enderecoNumero = "1734"
          this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
          this.modelCartao.comprador.enderecoCep = "58031130"
          this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
          this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
          this.modelCartao.comprador.enderecoEstado = "PARAIBA"
          // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
          this.modelCartao.cartao.nome = this.pagamento.nomeTitular
          // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
          this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
          this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
          this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
          this.modelCartao.cartao.bandeira = this.pagamento.bandeira

          // dados para a inscrição
          this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
          this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
          this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
          this.inscricao.cardHolderName = this.pagamento.nomeTitular
          this.inscricao.cardFlag = this.pagamento.bandeira
          this.atualizaInscricao()
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
            if (res.data) {
              this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
              this.inscricao.nsu = res.data.transacao.nsu
              this.inscricao.paymentId = res.data.pagamentoId
              this.inscricao.formOfPayment = 'CARTAO'
              this.inscricao.statusPagamento = "PAGO"
              await this.atualizaInscricao()
              this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
          }
        } else {
          this.isLoading = false
          var vm4 = this;
          vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
        }
      } else {
        this.$validator.validateAll()
      }
    }, */

    /* async pagarBoleto() {
      await this.realizarInscricao()
      if (this.idInscricao) {
        this.isLoading = true
        // criando data de vencimeto do boleto
        var datapagvenc = new Date();
        datapagvenc.setDate(new Date().getDate())
        // criando nosso número
        var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
        // preencher o campos do modelBoleto
        modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
        modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
        modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
        modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
        modelBoleto.pagadorCidade = "JOAO PESSOA"
        modelBoleto.pagadorUf = "PB"
        modelBoleto.pagadorCep = "58031130";
        modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
        // salvando o responsibility e o valor do boleto caso seja anual
        modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
        modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
        modelBoleto.nsu = this.inscricao.cod_incricao
        modelBoleto.nossoNumero = nossoNum.substr(0,12)
        modelBoleto.seuNumero = nossoNum.substr(0,12)
        // gerando o Boleto e pegando o ID
        try {
          let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
          if (res.data != '') {
            this.inscricao.boletoId = res.data.id
            this.inscricao.formOfPayment = 'BOLETO'
            this.inscricao.situacaoBoleto = 'GERADO'
            this.inscricao.nsu = modelBoleto.nsu
            this.inscricao.nossoNumero = modelBoleto.nossoNumero
            this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
            this.inscricao.statusPagamento = 'PENDENTE'
            await this.atualizaInscricao()
            await this.imprimirBoleto()
            await this.finalizaInscricao()
          }
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
          this.close()                 
        }                
      } else {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
      }
    }, */

    async pagamentoCartao() {
      let vm = this

      if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '') && (this.pagamento.cep != '') && (this.pagamento.numero != '') && (this.pagamento.email != '') && (this.pagamento.valor != 0)) {
        this.isLoading = true

        await this.realizarInscricao(null, 'CARTAO', this.textoParcela)
        await this.criarClienteAsaas()
        if (this.idInscricao.length > 0) {
          try {
           let codInscricaoGeral = this.inscricao[0].cod_incricao;
           
        if (this.inscricao.length > 1) {
            codInscricaoGeral += ' (qtd: ' + this.inscricao.length + ')';
    }
            this.cobrancaAsaasCartao.customer = this.idClienteAsaas
            this.cobrancaAsaasCartao.billingType = 'CREDIT_CARD'
            this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor)
            this.cobrancaAsaasCartao.installmentValue = parseFloat(parseFloat(this.pagamento.valor) / this.cobrancaAsaasCartao.installmentCount)
            this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaasCartao.description = 'Ref. ao evento ' + this.eventoSelecionado.nome + " para as insc. de nº " + codInscricaoGeral
            this.cobrancaAsaasCartao.inscricaoId = this.idInscricao
            this.cobrancaAsaasCartao.empresaId = this.empresa.id
            axios.get('https://api.ipify.org/?format=json')
              .then(res => {
                if (res.data) {
                  try {
                    this.cobrancaAsaasCartao.remoteIp = res.data.ip
                  } catch (error) {
                    this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                  }
                } else {
                  this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                }
              })
            // inserindo dados do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCard.holderName = this.pagamento.nomeTitular
            this.cobrancaAsaasCartao.creditCard.number = this.pagamento.cartaoNumero
            this.cobrancaAsaasCartao.creditCard.expiryMonth = this.pagamento.mesVencimento
            this.cobrancaAsaasCartao.creditCard.expiryYear = this.pagamento.anoVencimento
            this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv
            // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCardHolderInfo.name = this.pagamento.nomeTitular
            this.cobrancaAsaasCartao.creditCardHolderInfo.email = this.pagamento.email.trim().toLowerCase()
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj = this.pagamento.cpfTitular
            this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode = this.pagamento.cep
            this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber = this.pagamento.numero
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone = this.inscricao[0].telefone.replace(/[^\d]+/g, '')
            await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaasCartao)
              .then(response => {
                if (response.data.cobranca.status == 'CONFIRMED') {
                  this.finalizaInscricao()
                  if (this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
                }
              })
          } catch (error) {
            this.idInscricao = []
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.", "DESCULPE");
          }
        } else {
          this.idInscricao = []
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
        }
      } else {
        this.$validator.validateAll()
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para continuar!", "ATENÇÃO")
      }
    },

    async criarClienteAsaas() {
      this.clienteAsaas.name = this.pagePagamento ? this.pagamento.nomeTitular : this.inscricao[0].nome
      this.clienteAsaas.cpfCnpj = this.pagePagamento ? this.pagamento.cpfTitular : this.inscricao[0].cpf
      this.clienteAsaas.email = this.pagamento.email
      this.clienteAsaas.mobilePhone = this.inscricao[0].telefone.replace(/[^\d]+/g, '')
      this.clienteAsaas.postalCode = this.pagamento.cep
      this.clienteAsaas.addressNumber = this.pagamento.numero
      this.clienteAsaas.empresaId = this.empresa.id

      try {
        await axios.post(baseApiUrl + 'Pagamentos/criarCliente', this.clienteAsaas)
          .then(response => {
            if (response.data) {
              this.idClienteAsaas = response.data.id
            }
          })
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    async pagamentoBoleto() {
      this.isLoading = true

      await this.realizarInscricao(null, 'BOLETO', 'A VISTA')
      await this.criarClienteAsaas()
      if (this.idInscricao) {
        let codInscricaoGeral

        for (let i = 0; i < this.inscricao.length; i++) {
          if (this.inscricao.length > 1) {
            codInscricaoGeral += ' (qtd: ' + this.inscricao.length + ')';
        }
      }
        try {
          this.cobrancaAsaas.customer = this.idClienteAsaas
          this.cobrancaAsaas.value = (parseFloat(this.valorTotalCompra.replace(',', '.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',', '.'))).toFixed(2)
          this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
          this.cobrancaAsaas.billingType = 'BOLETO'
          this.cobrancaAsaas.description = 'Ref. ao evento ' + this.cultoSelecionado + " para as insc. de nº " + codInscricaoGeral
          this.cobrancaAsaas.inscricaoId = this.idInscricao
          this.cobrancaAsaas.empresaId = this.empresa.id
          await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas).then(res => {
            if (res.data) {
              this.linkBoleto = res.data.cobranca.bankSlipUrl
              this.finalizaInscricao()
              if (this.cupomAplicado)
                this.atualizaCupomsUtilizados()
            }
          })
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Problema encontrado ao gerar o boleto. Tente novamente mais tarde.", "DESCULPE");
        }
      } else {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    abreBoleto() {
      window.open(this.linkBoleto)
    },

    async pagarPixAsaas(valorCobranca) {
      this.isLoading = true

      await this.realizarInscricao(null, 'PIX', 'A VISTA')
      await this.criarClienteAsaas()
      if (this.idInscricao.length > 0) {
        try {
           let codInscricaoGeral = this.inscricao[0].cod_incricao;

      if (this.inscricao.length > 1) {
      codInscricaoGeral += ' (qtd: ' + this.inscricao.length + ')';
    }

          this.cobrancaAsaas.customer = this.idClienteAsaas
          this.cobrancaAsaas.value = (parseFloat(valorCobranca) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',', '.'))).toFixed(2)
          this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
          this.cobrancaAsaas.billingType = 'PIX'
          this.cobrancaAsaas.description = 'Ref. ao evento ' + this.eventoSelecionado.nome + " para as insc. de nº " + codInscricaoGeral
          this.cobrancaAsaas.inscricaoId = this.idInscricao
          this.cobrancaAsaas.empresaId = this.empresa.id
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas)
            .then(response => {
              if (response.data) {
                this.inscricao.codigoTransacao = response.data.cobranca.invoiceUrl
                this.qrCode64 = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
                this.chaveCopiaeCola = response.data.qrCode.payload
                this.msgResultado = 'Pré-inscrição realizada com sucesso'
                this.pagamentoPix = true
                this.isLoading = false
                this.inscricao.id = this.idInscricao
                this.consultaPagamentoPix(response.data.id)
                if (this.cupomAplicado)
                  this.atualizaCupomsUtilizados()
              }
            })
        } catch (error) {
          this.idInscricao = []
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
        }
      } else {
        this.idInscricao = []
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    consultaPagamentoPix() {
      try {
        this.verificaPagamento = setInterval(function () {
          axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta', { "inscricaoId": this.idInscricao[0], "empresaId": this.empresa.id })
            .then(res3 => {
              if (res3.data.status == 'RECEIVED') {
                this.finalizaInscricao()
                clearInterval(this.verificaPagamento)
              }
            })
        }.bind(this), 5000)
      } catch (error) {
        clearInterval(this.verificaPagamento)
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async pagarPixTaPago(valorPagamento) {
      this.isLoading = true

      await this.realizarInscricao(null, 'PIX', 'A VISTA')
      if (this.idInscricao.length > 0) {
        let dadosCobranca = {
          "empresaId": this.empresa.id,
          "inscricaoId": this.idInscricao,
          "valor": "",
          "descricao": 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
        }

        dadosCobranca.valor = (parseFloat(valorPagamento) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',', '.'))).toFixed(2)

        await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dadosCobranca)
          .then(response => {
            if (response.data) {
              this.qrCode64 = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
              this.chaveCopiaeCola = response.data.instantPayment.textContent
              this.msgResultado = 'Pré-inscrição realizada com sucesso'
              this.pagamentoPix = true
              this.isLoading = false
              //this.atualizaInscricao()
              this.consultaPagamentoPixTaPago()
              if (this.cupomAplicado)
                this.atualizaCupomsUtilizados()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          })
      } else {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    async consultaPagamentoPixTaPago() {
      try {
        this.verificaPagamento = setInterval(async function () {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', { "inscricaoId": this.idInscricao[0], "empresaId": this.empresa.id }).then(res3 => {
            if (res3.data.status == 'APPROVED') {
              this.isLoading = true
              this.finalizaInscricao()
              clearInterval(this.verificaPagamento)
            }
          })
        }.bind(this), 5000)
      } catch (error) {
        clearInterval(this.verificaPagamento)
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    async imprimirBoleto() {
      //Baixando Boleto PDF
      try {
        let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`, {
          responseType: 'arraybuffer', headers: {
            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
            'Content-type': 'application/pdf'
          }
        })
        if (res.data) {
          //Create a Blob from the PDF Stream
          const file = new Blob(
            [res.data],
            { type: 'application/pdf' }
          );
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', 'boleto.pdf'); //or any other extension
          document.body.appendChild(link);
          link.click();
          //Open the URL on new Window
          window.open(fileURL);
          //exibe mensagem de conclusao
          this.isLoading = false
          this.dialogLoading = true
        }
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!", "ERRO");
      }
    },

    finalizaInscricao() {
      this.isLoading = false
      if (this.inscricao.formOfPayment == 'CARTAO') {
        this.msgResultado = 'Compra realizada com sucesso!'
        this.dialogoListaIngresso = true
      } else if (this.inscricao.formOfPayment == 'BOLETO') {
        this.msgResultado = 'Pré inscrição realizada com sucesso!'
        this.confirmacaoBoleto = true
      } else if (this.inscricao.formOfPayment == 'EM MAOS') {
        this.msgResultado = 'Pré inscrição realizada com sucesso!'
        this.confirmacaoEmMaos = true
      } else {
        this.pagamentoPix = false
        this.msgResultado = 'Compra realizada com sucesso!'
        this.dialogoListaIngresso = true
      }
    },

    //Função para criptografia
    encrypt(text) {
      let crypto = require('crypto');
      let password = 'pxuelh2so839ljis';
      let iv = 'pxuelh2so839ljis';
      let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
      let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');
      return encryptedData;
    },

    closeDialog() {
      this.pagamentoPix = false
      if (!this.consultaCPF) {
        this.reloadPage()
      }
      this.$validator.reset()
      if (this.consultaCPF) {
        this.consultaCPF = false
        this.inscricao = Object.assign({}, this.inscricaoDefault)
      }
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.nome;
      const dataB = b.nome;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    calculateAge(dobString) {
      var dob = new Date(dobString);
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
      var age = currentYear - dob.getFullYear();
      if (birthdayThisYear > currentDate) {
        age--;
      }
      return age;
    },

    formatDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },

    async pegaParametrosUrl() {
      var params = window.location.search.substring(1).split('&');
      if (params[0] != '') {
        this.isLoading = true
        let paramArray = {};                        // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
          var param = params[i].split('=');         // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
        }

        if (paramArray['cod']) {
          await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCodigo', { "cod_incricao": paramArray['cod'] })
            .then(async response => {
              if (response.data) {
                if (response.data.statusPagamento == 'PAGO') {
                  this.inscricaoLocalizada = Object.assign({}, response.data)
                  this.dialogoIngressoIndividual = true
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Pagamento da inscrição não foi efetuado.", "ATENÇÃO");
                }
              }
            })
        }
        if (paramArray['d']) {
          this.consultaDivulgador(paramArray['d'])
        }
        if (paramArray['e']) {
          let evento = this.eventos.filter(evento => evento.id == paramArray['e'])
          this.realizarInscricaoGrupo(evento[0])
        }
      }
      this.isLoading = false
    },

    async salvaHoraVisualizacao(id) {
      await axios.patch(baseApiUrl + 'inscricoes/' + id, { "visualizado": true, "ultimaVisualizacao": moment().toISOString() })
    },

    async consultarInscricao(cpf, cod) {
      var vm = this;
      if (cpf) {
        this.isLoading = true
        let envio = {
          "eventoId": this.eventoId,
          "cpf": cpf,
          "enviaToken": true,
          "canalNotificacao": "ZAP",
          "cod_incricao": cod
        }
        try {
          await axios.post(`${baseApiUrl}inscricoes/consultarInscricao`, envio).then(response => {
            if (response.data.length > 0) {
              this.idInscricao = response.data
              this.dialogoToken = true
              this.consultaCPF = true
              this.isLoading = false
            }
          })
        } catch (error) {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao consultar inscrição, tente novamente!", "DESCULPE");
        }
      } else {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o CPF para consultar", "ATENÇÃO");
      }
    },

    async confirmaToken() {
      var vm = this;
      if (this.token) {
        this.isLoading = true
        let confirmacao = {
          "token": this.token,
          "inscricaoId": this.idInscricao
        }
        await axios.post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then(response => {
            if (response.data) {
              if (response.data.statusPagamento == 'PAGO') {
                this.consultaCPF = true
                this.cultoSelecionado = this.eventos[0].nome
                this.inscricao.nome = response.data.nome
                this.inscricao.cod_incricao = response.data.cod_incricao
                this.inscricao.email = response.data.email
                this.inscricao.participantes = response.data.participantes
                this.dialogoToken = false
                this.token = ''
                this.dialogoIngressoIndividual = true
                this.isLoading = false
                this.idInscricao = ''
              } else if (response.data.statusPagamento == 'PENDENTE') {
                this.inscricaoLocalizada = true
                this.consultaInscricao(this.idInscricao)
                if (response.data.participantes > 1) {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoGrupo()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                } else {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoAgora()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                }
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'CANCELADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação cancelada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'ESTORNADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação estornada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              }
            } else {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Token inválido, tente novamente", "ATENÇÃO")
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar token, tente novamente", "DESCULPE")
          })
      } else {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o token enviado para continuar", "ATENÇÃO")
      }
    },

    async consultaInscricao(id) {
      await axios.get(baseApiUrl + 'inscricoes/' + id)
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data.nome
            this.inscricao.cpf = response.data.cpf
            this.inscricao.dataNascimento = response.data.dataNascimento
            this.inscricao.telefone = response.data.telefone
            this.inscricao.possuiNecessidade = response.data.possuiNecessidade
            this.inscricao.necessidadeEspecial = response.data.necessidadeEspecial
          }
        })
    },

    async consultaDivulgador(id) {
      await axios.get(baseApiUrl + 'Divulgadores/' + id)
        .then(response => {
          if (response.data) {
            if (response.data.ativo) {
              this.indicacao = true
              this.divulgador = response.data
              axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 })
            }
          }
        })
    },

    retornaData(tipo) {
      return moment().format(tipo)
    },

    retornaPaginaPrincipal() {
      this.eventoSelecionado = []
      this.inscricao = this.inscricaoDefault

      if (this.PageIncricao) {
        this.PageIncricao = false
      } else {
        this.paginaInscricaoGrupo = false
      }

      this.pagePrincipal = true
    },

    async buscaUfs() {
      await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then(response => {
          if (response.data) {
            this.estados = response.data
          }
        })
    },

    async buscaMunicipios() {
      await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado')
        .then(response => {
          if (response.data) {
            this.municipios = response.data
          }
        })
    },

    calculaValorTotal(nome, indice) {
      let vm = this

      // localiza o setor escolhido pelo preço e o salva na inscrição
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        if (this.eventoSelecionado.setores[i].nome == nome) {
          if (this.verificaVagaDisponivel(this.eventoSelecionado.setores[i].nome) > 0) {
            this.inscricao[indice].corSetor = this.eventoSelecionado.setores[i].cor
          } else {
            this.inscricao[indice].setor = ''
            this.inscricao[indice].corSetor = ''
            vm.$refs.chamaSnackbar.snack("#F9A825", "Quantidade máxima atingida para o setor", "ATENÇÃO")
          }
          break
        }
      }

      if (this.empresa.limiteInscricao == 'SETOR') {
        this.pegaVagasDisponiveis()
      }
    },

    async pegaVagasDisponiveis() {
      await axios.post(baseApiUrl + 'Empresas/vagasDisponiveis', { "empresaId": this.empresa.id })
        .then(response => {
          if (response.data) {
            this.vagasDisponiveis = response.data
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] = this.vagasDisponiveis[this.inscricao[i].setor] - 1
              }
            }
          }
        })
    },

    verificaVagaDisponivel(setor) {
      return this.vagasDisponiveis[setor] - 1
    },

    async retornoCEP() {
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.empresaCompra.cep)) {
        await axios.get(`https://viacep.com.br/ws/${this.empresaCompra.cep.replace(/[^\d]+/g, '')}/json/`)
        .then(response => {
          if (response.data.erro == true || response.data.erro == 'true' || response.data.bairro == '' || response.data.localidade == '' || response.data.uf == '') {
            this.empresaCompra.logradouro = ''
            this.empresaCompra.estado = ''
            this.empresaCompra.cidade = ''
            this.empresaCompra.bairro = ''
            this.cepNotCaptured = true
            var vmcep = this;
            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado! Preencha os campos manualmente.","ATENÇÃO")
          } else {
            this.empresaCompra.logradouro = response.data.logradouro.toUpperCase()
            this.empresaCompra.estado = response.data.uf.toUpperCase()
            this.empresaCompra.cidade = response.data.localidade.toUpperCase()
            this.empresaCompra.bairro = response.data.bairro.toUpperCase()
            this.cepNotCaptured = false
          }
        })
      }
    },
    
    visualizarIngressoIndividual(item) {
      this.inscricao = [item];
      
      // Preencher inscricaoLocalizada com os dados do ingresso
      this.inscricaoLocalizada = {
        cod_incricao: item.cod_incricao,
        nome: item.nome,
        email: item.email,
        sexo: item.sexo,
        telefone: item.telefone,
        eventoNome: this.eventoSelecionado.nome,
        eventoLocal: this.eventoSelecionado.local,
        eventoLocalizacao: this.eventoSelecionado.localizacao,
        eventoUsaCartaoConsumo: this.eventoSelecionado.usaCartaoConsumo,
        setor: "",
        corSetor: "",
        autopreenchimento: item.autopreenchimento
      };
      
      this.dialogoIngressoIndividual = true;
      this.dialogoListaIngresso = false;
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #142c52, #92c1e1);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 0px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

.no-break {
  word-wrap: normal;
  /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
  word-break: keep-all;
  /* Isso também ajuda a prevenir a quebra no meio de palavras */
  white-space: pre-line;
  /* Isto vai respeitar os espaços em branco e quebras de linha */
}

a {
  text-decoration: none
}

.qrcode-area-clicavel {
  position: relative;
  overflow: hidden;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(245, 158, 11, 0.1);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.qrcode-area-clicavel:hover .hover-overlay {
  opacity: 1;
}
</style>
